import * as marietta from '../..';
import { ALMOST_ZERO } from '../Constants';
import { SVGSprite } from '../flash/display';
import ItemControllerRoom from './ItemControllerRoom';

/**
 * guide Itemcontrollerクラス
 */
export default class ItemControllerColumnWithGuide extends ItemControllerRoom {
  itemguide: marietta.webcad.control.parts.ItemGuide;

  itemBoundRectRight: marietta.webcad.control.parts.ItemBoundRect;

  itemBoundRectLeft: marietta.webcad.control.parts.ItemBoundRect;

  itemBoundRectTop: marietta.webcad.control.parts.ItemBoundRect;

  itemBoundRectBottom: marietta.webcad.control.parts.ItemBoundRect;

  distanceTop: any;

  distanceRight: any;

  distanceBottom: any;

  distanceLeft: any;

  public guideSpt: SVGSprite;

  public itemBoundGuideSpt: SVGSprite;

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
  }

  /**
  * 初期化
  */
  initMe():void {
    this.cornerPickerList = [];
    this.movePickerList = [];

    // コントローラー追加
    const points: number = this.target.itemInfo.dotList.length;
    let corner: marietta.webcad.control.parts.RoomCornerDragger;
    let wallPicker: marietta.webcad.control.parts.RoomMovePicker;
    for (let i: number = 1; i <= points; i += 1) {
      corner = new marietta.webcad.control.parts.RoomCornerDragger(this.spt, i);
      corner.moveFunc = this.onMoveCornerDragger;
      corner.moveEndFunc = this.onMoveEndCornerDragger;
      this.cornerPickerList.push(corner);

      wallPicker = new marietta.webcad.control.parts.RoomMovePicker(this.spt, i);
      wallPicker.moveFunc = this.onMoveWallDragger;
      wallPicker.moveEndFunc = this.onMoveEndWallDragger;
      this.movePickerList.push(wallPicker);
    }
    if (document.getElementById('controller_snap_guide')) {
      document.getElementById('controller_snap_guide').remove();
    }

    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;

    const viewItemBoundGuide: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewItemBoundGuide.id = 'itemBoundGuide';
    this.itemBoundRectRight = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectRight');
    this.itemBoundRectLeft = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectLeft');
    this.itemBoundRectTop = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectTop');
    this.itemBoundRectBottom = new marietta.webcad.control.parts.ItemBoundRect(viewItemBoundGuide, 'itemBoundRectBottom');
    tarLayer.viewObj.appendChild(viewItemBoundGuide);
    this.itemBoundGuideSpt = new SVGSprite(viewItemBoundGuide);

    // バウンドボックスとガイドライン
    const viewObjGuide: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObjGuide.id = 'guide';
    this.itemguide = new marietta.webcad.control.parts.ItemGuide(viewObjGuide);
    tarLayer.viewObj.appendChild(viewObjGuide);
    this.guideSpt = new SVGSprite(viewObjGuide);
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible) {
      this.hideItemGuide();
    }
    tarLayer.spt.addChild(this.spt);

    // コントローラーの位置調整
    this.setArrowPositions();

    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();

    const boundBox = this.target.getBoundRect();
    this.itemguide.move(boundBox.x+boundBox.width/2, boundBox.y+boundBox.height/2);
    this.itemguide.resize({ width: boundBox.width, height: boundBox.height });
    this.updateTransforms();
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    const dist = this.calculateDistance();
    if (dist && dist.top !== undefined && dist.right !== undefined && dist.bottom !== undefined && dist.left !== undefined) {
      this.showGuide(dist.top, dist.right, dist.bottom, dist.left);
    } else {
      this.hideItemGuide();
    }
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.update();
  }

  /**
   * 隣接する壁またはアイテムからの距離の計算
   */
  calculateDistance() {
    this.itemguide.hideAllDifferenceLine();
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.roomWallList || !marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible) return null;

    if (this.target.itemInfo.x !== undefined) {
      const boundBox = this.target.getBoundRect();
      // let center = new marietta.core.Point(boundBox.x+Math.round(boundBox.width) / 2, boundBox.y+Math.round(boundBox.height) / 2);
      const topL = new marietta.core.Point(boundBox.x, boundBox.y);
      const topR = new marietta.core.Point(boundBox.x + Math.round(boundBox.width), boundBox.y);
      const bottomL = new marietta.core.Point(boundBox.x, boundBox.y + Math.round(boundBox.height) );
      const bottomR = new marietta.core.Point(boundBox.x + Math.round(boundBox.width), boundBox.y + Math.round(boundBox.height));

      this.distanceTop = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, topL, topR, 'top'); // 選択したアイテムの上にある隣接する壁またはアイテムからの距離
      this.distanceRight = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, topR, bottomR, 'right'); // 選択したアイテムの右側にある隣接する壁またはアイテムからの距離
      this.distanceBottom = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, bottomL, bottomR, 'bottom'); // 選択したアイテムの下にある隣接する壁またはアイテムからの距離
      this.distanceLeft = marietta.webcad.util.ItemGuideUtil.getClosestWallOrItem(this.target, topL, bottomL, 'left'); // 選択したアイテムの左側にある隣接する壁またはアイテムからの距離
    }

    return {
      top: this.distanceTop, right: this.distanceRight, bottom: this.distanceBottom, left: this.distanceLeft,
    };
  }

  /**
   * ガイドビューを表示
   * @param distanceTop
   * @param distanceRight
   * @param distanceBottom
   * @param distanceLeft
   */
  showGuide(distanceTop, distanceRight, distanceBottom, distanceLeft) {
    if ((distanceTop && distanceTop.distance != null) && (distanceRight && distanceRight.distance != null) && (distanceBottom && distanceBottom.distance != null) && (distanceLeft && distanceLeft.distance != null)) {
      const guideList = [distanceTop, distanceRight, distanceBottom, distanceLeft];
      let boundBox = this.target.getBoundRect();
      let center = new marietta.core.Point(boundBox.x+Math.round(boundBox.width) / 2, boundBox.y+Math.round(boundBox.height) / 2);
      guideList.forEach((guide: any) => {
        const guidObj = guide;
        guidObj.startPoint.x -= center.x;
        guidObj.startPoint.y -= center.y;
        guidObj.point.x -= center.x;
        guidObj.point.y -= center.y;
      });
      this.createItemBoundRect();
      this.itemguide.updateDistanceLine(distanceTop, distanceRight, distanceBottom, distanceLeft);
      this.itemguide.show();
    } else {
      this.itemguide.hide();
    }
  }

  /**
   * 交差するアイテムの境界線
   */
  createItemBoundRect() {
    this.itemBoundRectRight.hide();
    this.itemBoundRectLeft.hide();
    this.itemBoundRectTop.hide();
    this.itemBoundRectBottom.hide();
    if (this.distanceRight.isItem) {
      const boundBox = this.distanceRight.item.getBoundRect();
      this.itemBoundRectRight.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceRight.item.itemInfo);
      this.itemBoundRectRight.show();
    }
    if (this.distanceTop.isItem) {
      const boundBox = this.distanceTop.item.getBoundRect();
      this.itemBoundRectTop.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceTop.item.itemInfo);
      this.itemBoundRectTop.show();
    }
    if (this.distanceBottom.isItem) {
      const boundBox = this.distanceBottom.item.getBoundRect();
      this.itemBoundRectBottom.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceBottom.item.itemInfo);
      this.itemBoundRectBottom.show();
    }
    if (this.distanceLeft.isItem) {
      const boundBox = this.distanceLeft.item.getBoundRect();
      this.itemBoundRectLeft.resize({ width: Math.round(boundBox.width), height: Math.round(boundBox.height), x: boundBox.x, y: boundBox.y }, this.distanceLeft.item.itemInfo);
      this.itemBoundRectLeft.show();
    }
  }

  /**
   * 距離テキストボックスへの入力に関してアイテムを移動する
   * @param newDistance
   * @param direction
   */
  moveItemWithInput(newDistance: number, direction: string): void {
    if (this.target.itemInfo.lock) return;
    let distance = newDistance;
    this.target.saveCurrentPosition();
    if (distance != null) {
      if (distance < ALMOST_ZERO) distance = ALMOST_ZERO;
      const distInPix = marietta.webcad.util.WebCADUtil.convertMMToPix(distance);
      switch (direction) {
        case 'Top':
          if (!this.distanceTop) return;
          if (distInPix < this.distanceTop.distance) {
            this.target.itemInfo.y -= (this.distanceTop.distance - distInPix);
          } else {
            this.target.itemInfo.y += (distInPix - this.distanceTop.distance);
          }
          break;
        case 'Right':
          if (!this.distanceRight) return;
          if (distInPix < this.distanceRight.distance) {
            this.target.itemInfo.x += (this.distanceRight.distance - distInPix);
          } else {
            this.target.itemInfo.x -= (distInPix - this.distanceRight.distance);
          }
          break;
        case 'Bottom':
          if (!this.distanceBottom) return;
          if (distInPix < this.distanceBottom.distance) {
            this.target.itemInfo.y += (this.distanceBottom.distance - distInPix);
          } else {
            this.target.itemInfo.y -= (distInPix - this.distanceBottom.distance);
          }
          break;
        case 'Left':
          if (!this.distanceLeft) return;
          if (distInPix < this.distanceLeft.distance) {
            this.target.itemInfo.x -= (this.distanceLeft.distance - distInPix);
          } else {
            this.target.itemInfo.x += (distInPix - this.distanceLeft.distance);
          }
          break;
        default: break;
      }
      this.target.updateTransforms();
      this.setArrowPositions();
      // marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
      if (this.target.previousPlace && marietta.core.Point.distance(this.target.previousPlace, new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y)) !== 0) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }
    }
  }

  // アイテムガイドの表示
  showItemGuide() {
    const dist = this.calculateDistance();
    if (dist && dist.top !== undefined && dist.right !== undefined && dist.bottom !== undefined && dist.left !== undefined) {
      this.showGuide(dist.top, dist.right, dist.bottom, dist.left);
    } else {
      this.hideItemGuide();
    }
  }

  // アイテムガイドの非表示
  hideItemGuide() {
    this.itemguide.hide();
    if (document.getElementById('itemBoundGuide')) {
      document.getElementById('itemBoundGuide').remove();
    }
  }
}
